import GlobalSettingsPage from "./GlobalSettingsPage";

export default GlobalSettingsPage;
